import { PromotionTypes } from 'utils/Enums';

export const PromoInfoFormFieldNames = {
    PromoType: 'promoType',
    TacticType: 'tacticType',
    FeatureQuality: 'featureQuality',
    DisplayQuality: 'displayQuality',
    OfferMethod: 'offerType',
    ManualOffer: 'manualOffer',
    PromoStartDate: 'promoStartDate',
    PromoEndDate: 'promoEndDate',
    CRAEndDate: 'craEndDate',
    CRAStartDate: 'craStartDate',
    status: 'status',
    FundingRequest: 'fundingRequest',
    ParNumber: 'parNumber',
    IsmCampaignId: 'ismCampaignId',
    ContractNumber: 'contractNumber',
    PromoName: 'name',
    PromoId: 'promoId',
    SuggestedOfferType: 'suggestedOfferType',
    BuyFor: 'buy_for',
};

export const OPTIMIZATION_POLLING_INTERVAL = 12000;

export const INFEASIBLE_SOLUTION_KEYWORDS = ['no solution exists'];

export const TPO_QUERY_KEYS = {
    GET_METRICS_RECOMMENDED_VALUES: 'get_metrics_recommended_values',
} as const;

export const LAST_UPDATED_POLLING_INTERVAL = 10000;

export const TPO_UI_LIMITS = {
    PPG_SELECTION: 50,
    PLAN_NAME_MAX_LENGTH: 50,
};

export const MANDATORY_NON_CALENDAR_COLUMN_DATA_KEYS = ['event', 'promo'];

export const PROMO_LIMITS = {
    BRAND_MAX_LENGTH: 13,
    MECHANIC_MAX_LENGTH: 20,
};

export const TpoMessages = {
    error: {
        FAILED_TO_SAVE: 'Failed to save promo details.',
        EDLP_PROMO_CRA_DATE: "'EDLP' requires Promo Dates to match CRA Dates exactly.",

        INVALID_VALUE: (metricName: string, invalidValue: any) => `${metricName} can't be ${invalidValue}`,
        NON_EDLP_PROMOTED_SRP_EXCEEDS: (violations: string[]) =>
            `The Promoted SRP for [${violations.join(
                ', ',
            )}] exceeds the EDLP SRP. Please adjust the pricing accordingly.`,
        MERCH_SHOULD_HAVE_MINIMUM_ONE_SPEND: 'Merchandising promotion should have at least one spend',
        TPO_ADJUSTED_BASE_UNITS_CANNOT_BE_NEGATIVE: (ppgNames: string[]) =>
            `TPO Base Units is negative for ${ppgNames.join(',')}`,
        INVALID_PROMO_DATE: "Promo dates can't be in the past",
        FIXED_SPENDS_FOR_MDF_ISM_PROMOTIONS: 'MDF and ISM Promotions require atleast one spend to be added',
    },

    success: {
        PROMO_CREATED: 'Promotion has been successfully created.',
        DATA_SAVED: 'Changes have been saved successfully.',
        BULK_UPLOAD_SUCCESS: (count: number) => `${count} records were updated successfully.`,
    },
    info: {
        CHANGES_ARE_BEING_SAVED: 'Your current changes are being saved. Please wait.',
        TRADE_RATE_EXCEEDS_50_INFO: (warnings: string[]) =>
            `Trade rate exceeds 50% of the list price for the following products: ${warnings.join(', ')}. `,
        NO_MATCHING_KPIS: 'No matching KPIs were found for the selected filters.',
        UNSAVED_CHANGES: 'You have unsaved changes. Proceed with caution.',
        EDLP_PPG_QUARTER_SPAN: (miscMetric: string, scanMetric: string, ppgs: string[]) =>
            `The following PPGs cannot span quarters when ${miscMetric} or ${scanMetric} is greater than 0: [ ${ppgs.join(
                ', ',
            )} ]`,
        COGS_PER_UNIT_MISSING_OR_ZERO: (ppgs: string[]) =>
            `COGS per unit is missing or zero for the following material group(s): ${ppgs.join(', ')}.`,
    },
};

export const PromotionTypesShortNames = {
    [PromotionTypes.EDLP]: 'EDLP',
    [PromotionTypes.Merchandising]: 'MERCH',
    [PromotionTypes.SM_MDF]: 'MDF',
    [PromotionTypes.SM_ISM]: 'ISM',
    [PromotionTypes.Slotting]: 'SLOTTING',
    [PromotionTypes.Post_Audit]: 'POST-AUDIT',
    [PromotionTypes.Write_Off]: 'WRITE-OFF',
};

export enum PublishStatus {
    PUBLISH_IN_PROGRESS = 'publish_in_progress',
    FAILED_TO_PUBLISH = 'failed_to_publish',
    PUBLISHED = 'published',
}

export enum PromoStatus {
    DRAFT = 'draft',
    PLANNED = 'planned',
    SUBMITTED_FOR_APPROVAL = 'submitted_for_approval',
    PENDING_APPROVAL = 'pending approval',
    REJECTED = 'rejected',
    APPROVED = 'approved',
    CUSTOMER_ACCEPTED = 'customer_accepted',
    CANCELLED = 'cancelled',
    EXECUTED = 'executed',
}
